'use strict';
const Constants = require('../constants');
const ObjectAssign = require('object-assign');
const ParseValidation = require('../../../../helpers/parse-validation');
const Redux = require('redux');


const initialState = {
    loading: false,
    success: false,
    error: undefined,
    secretRequired: false,
    generateSecretLink: null,
    hasError: {},
    help: {}
};
const reducer = function (state = initialState, action) {

    if (action.type === Constants.LOGIN) {
        return ObjectAssign({}, state, {
            loading: true
        });
    }

    if (action.type === Constants.LOGIN_RESPONSE) {
        const validation = ParseValidation(action.response);

        return ObjectAssign({}, state, {
            loading: false,
            success: !action.err,
            error: validation.error,
            hasError: validation.hasError,
            help: validation.help,
            secretRequired: action.response && (action.response.statusCode === 499 || action.response.type === '2FA'),
        });
    }

    if (action.type === Constants.CLEAR) {
        return ObjectAssign({}, initialState);
    }


    return state;
};


module.exports = Redux.createStore(reducer);



// WEBPACK FOOTER //
// ./client/pages/main/login/home/store.js